export const getFauluLoanCalculator = state => state.fauluLoanCalculatorStore;